import React from 'react';
import { Link } from '@ktag/styleguide/dist/react';
import { Button } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import Scrollable from '../../components/scrollable/Scrollable';

const releaseVersion = import.meta.env.VITE_APP_VERSION || 'N/A';

const Help = () => {
  const { t } = useTranslation('agisviewer');
  const setActiveView = useAppState((state) => state.setActiveView);

  return (
    <div className="tooldialog__wrapper">
      <Scrollable>
        <div className="tooldialog__wrapper-content">
          <p>
            {t('help_video')}
            <br />
            <Link
              text={t('help_video_link')}
              title={t('help_video_link')}
              url="https://www.ag.ch/de/themen/staat-politik/daten-und-zahlen/geoportal/online-karten#NjkxNTQ4Mw "
              openNewWindow
            />
          </p>
          <p>
            {t('help_manual')}
            <br />
            <Link
              text={t('help_manual_link')}
              title={t('help_manual_link')}
              url="https://www.ag.ch/de/themen/staat-politik/daten-und-zahlen/geoportal/online-karten#NjkxNTQ4Mw"
              openNewWindow
            />
          </p>

          <p>
            {t('help_infotext')}
            <br />
            <Link
              text={t('help_question_link')}
              title={t('help_question_link')}
              url="https://www.ag.ch/de/themen/staat-politik/daten-und-zahlen/geoportal/online-karten#Njc5ODM1Nw"
              openNewWindow
            />
          </p>

          <p>
            {t('help_feedback_text')}
            <br />
            <Link
              text={t('help_feedback_link')}
              title={t('help_feedback_link')}
              url="https://www.ag.ch/de/verwaltung/dfr/geoportal/kontaktformular"
              openNewWindow
            />
          </p>
        </div>
      </Scrollable>

      <div className="tooldialog__wrapper-content release_note">
        <p>
          Version: {releaseVersion}
          <br />
          <Button
            additionalClassNames="button__as-link"
            title={t('help_release_notes')}
            onClick={() => setActiveView('help_tool_relase_notes')}
          >
            {t('help_release_notes')}
          </Button>
          <br />
          {t('help_copywrite')}
          <br />
          <Link
            text={t('help_legal_note_link')}
            title={t('help_legal_note_link')}
            url="https://www.ag.ch/de/ueber-uns/rechtliche-hinweise"
            openNewWindow
          />
          <br />
          <Link
            text={t('help_geoporatal_link')}
            title={t('help_geoporatal_link')}
            url="https://www.ag.ch/de/verwaltung/dfr/geoportal"
            openNewWindow
          />
        </p>
      </div>
    </div>
  );
};

export default Help;
